var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-684.5 609.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(591.467 695.976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.992,728.025a.492.492,0,0,1-.492-.492v-7.541a.492.492,0,0,1,.984,0v7.541A.492.492,0,0,1,595.992,728.025Z",
    transform: "translate(-595.5 -719.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(591.467 684.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.992,692.953a.492.492,0,0,1-.492-.492v-7.469a.492.492,0,0,1,.984,0v7.469A.492.492,0,0,1,595.992,692.953Z",
    transform: "translate(-595.5 -684.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.549 692.369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.992,720.632a.492.492,0,0,1-.492-.492V708.992a.492.492,0,0,1,.984,0V720.14A.492.492,0,0,1,641.992,720.632Z",
    transform: "translate(-641.5 -708.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.549 684.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.992,689.287a.492.492,0,0,1-.492-.492v-3.8a.492.492,0,0,1,.984,0v3.8A.492.492,0,0,1,641.992,689.287Z",
    transform: "translate(-641.5 -684.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.008 699.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.992,736.09a.492.492,0,0,1-.492-.492v-3.607a.492.492,0,0,1,.984,0V735.6A.492.492,0,0,1,618.992,736.09Z",
    transform: "translate(-618.5 -731.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.008 684.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.992,696.894a.492.492,0,0,1-.492-.492v-11.41a.492.492,0,0,1,.984,0V696.4A.492.492,0,0,1,618.992,696.894Z",
    transform: "translate(-618.5 -684.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(597.041 695.976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.959,724.418a2.459,2.459,0,1,1,2.459-2.459A2.462,2.462,0,0,1,614.959,724.418Zm0-3.935a1.475,1.475,0,1,0,1.475,1.475A1.477,1.477,0,0,0,614.959,720.484Z",
    transform: "translate(-612.5 -719.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.582 688.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.959,701.418a2.459,2.459,0,1,1,2.459-2.459A2.462,2.462,0,0,1,637.959,701.418Zm0-3.935a1.475,1.475,0,1,0,1.475,1.475A1.477,1.477,0,0,0,637.959,697.484Z",
    transform: "translate(-635.5 -696.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.499 692.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.958,712.418a2.459,2.459,0,1,1,2.459-2.459A2.462,2.462,0,0,1,591.958,712.418Zm0-3.935a1.475,1.475,0,1,0,1.475,1.475A1.478,1.478,0,0,0,591.958,708.484Z",
    transform: "translate(-589.499 -707.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.ce8e12e622ec08432453fecdd3700ca7.svg";
export { ForwardRef as ReactComponent };